/** @jsxImportSource @emotion/react */
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import { Checkbox, FormControl, FormHelperText, InputLabel, ListItemText, MenuItem, Select } from "@mui/material";
import PropTypes from "prop-types";

const StarsSelectInput = (props) => {
  const isSelectAllIndeterminate = () => {
    return props.value.length !== props.allOptions.length && props.value.length !== 0;
  };

  const isSelectAllChecked = () => {
    return props.value.length === props.allOptions.length;
  };

  const onChange = (event) => {
    if (event.target.value.includes("Select All")) {
      if (isSelectAllChecked()) {
        event.target.value = [];
      } else {
        event.target.value = props.allOptions;
      }
    }
    props.onChange(event);
  };

  const renderMenuItems = () => {
    let renderedItems = props.allOptions.slice();
    renderedItems = props.sortComparator ? renderedItems.sort((a, b) => props.sortComparator(a, b)) : renderedItems;
    return renderedItems.map((option) => {
      return (
        <MenuItem key={option} value={option} disabled={props.isMenuItemDisabled(option)}>
          {props.multiple && <Checkbox color="primary" checked={props.value.indexOf(option) > -1} />}
          {option}
        </MenuItem>
      );
    });
  };

  return (
    <FormControl variant="outlined" data-testid="stars-select-input" fullWidth={props.fullWidth}>
      <InputLabel>{props.label}</InputLabel>
      <Select
        className={props.className}
        sx={props.sx}
        label={props.label}
        multiple={props.multiple}
        MenuProps={{ autoFocus: false }}
        value={props.value}
        onChange={(event) => onChange(event)}
        renderValue={
          props.multiple
            ? (selected) =>
                selected.length === props.allOptions.length ? "ALL" : selected.length === 1 ? selected[0] : "MULTI"
            : undefined
        }
        error={props.errors !== ""}
        disabled={props.disabled}
      >
        <MenuItem disabled>
          <em>{props.menuMessage}</em>
        </MenuItem>
        {props.multiple && (
          <MenuItem key="select-all" value="Select All">
            <Checkbox
              color="primary"
              checked={isSelectAllChecked()}
              indeterminate={isSelectAllIndeterminate()}
              indeterminateIcon={<IndeterminateCheckBoxIcon color="primary" />}
            />
            <ListItemText primary="Select All" />
          </MenuItem>
        )}
        {renderMenuItems()}
      </Select>
      {props.errors !== "" && <FormHelperText error>{props.errors}</FormHelperText>}
    </FormControl>
  );
};

StarsSelectInput.propTypes = {
  label: PropTypes.string.isRequired,
  menuMessage: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  allOptions: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.string.isRequired,
  className: PropTypes.string,
  sx: PropTypes.object,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  isMenuItemDisabled: PropTypes.func,
  fullWidth: PropTypes.bool,
  sortComparator: PropTypes.func,
};

StarsSelectInput.defaultProps = {
  isMenuItemDisabled: () => false,
};

export default StarsSelectInput;
